import axios from 'axios'
import { push } from 'react-router-redux'
import reduce from 'lodash/reduce'
import { createFlash, createError } from './flasher'

const baseAPI = process.env.REACT_APP_BASE_API

export const fetchPlans = (id, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: 'FETCH_PLANS_PENDING'
    })
    return axios({
      method: 'get',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${id}/plans`
    }).then((x) => {
      dispatch({
        type: 'FETCH_PLANS_FULFILLED',
        payload: {
          data: x.data,
          pagination: {
            currentPage: x.headers['x-pagination-current-page'],
            pageCount: x.headers['x-pagination-page-count'],
            perPage: x.headers['x-pagination-per-page'],
            totalCount: x.headers['x-pagination-total-count']
          }
        }
      })
    }).catch((e) => {
      console.error(e)
      dispatch({
        type: 'FETCH_PLANS_REJECTED',
        payload: e
      })
    })
  }
}

export const fetchGlobalPlans = (query = '', accessToken) => {
  const queryString = typeof query === 'object'
    ? reduce(query, (x, val, key) => (
      x + key + '=' + val + '&'
    ), '')
    : query
  return (dispatch) => {
    dispatch({
      type: 'FETCH_GLOBAL_PLANS_PENDING'
    })
    return axios({
      method: 'get',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/plans${queryString}`
    }).then((x) => {
      dispatch({
        type: 'FETCH_GLOBAL_PLANS_FULFILLED',
        payload: {
          data: x.data,
          pagination: {
            currentPage: x.headers['x-pagination-current-page'],
            pageCount: x.headers['x-pagination-page-count'],
            perPage: x.headers['x-pagination-per-page'],
            totalCount: x.headers['x-pagination-total-count']
          }
        }
      })
    }).catch((e) => {
      console.error(e)
      dispatch(createError(e?.response?.data || 'Error 892734'))
      dispatch({
        type: 'FETCH_GLOBAL_PLANS_REJECTED',
        payload: e
      })
    })
  }
}

export const fetchPlan = (orderId, id, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: 'FETCH_PLAN_PENDING'
    })
    return axios({
      method: 'get',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${orderId}/plans/${id}`
    }).then((x) => {
      dispatch({
        type: 'FETCH_PLAN_FULFILLED',
        payload: x.data
      })
    }).catch((e) => {
      dispatch({
        type: 'FETCH_PLAN_REJECTED',
        payload: e
      })
    })
  }
}

export const createPlan = (data, accessToken, target) => {
  return (dispatch) => {
    dispatch({
      type: 'CREATE_PLAN_PENDING'
    })
    return axios({
      data,
      method: 'post',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${data.order_id}/plans`
    }).then((x) => {
      dispatch({
        type: 'CREATE_PLAN_FULFILLED',
        payload: x.data
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'success',
        message: `Plan created with the id ${x.data.id}`
      }))
      if (target) {
        dispatch(push(target))
      } else {
        dispatch(push(`/orders/${x.data.order.id}/plans/${x.data.id}`))
      }
    }).catch((e) => {
      dispatch({
        type: 'CREATE_PLAN_REJECTED',
        payload: e
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'error',
        message: `Update error`
      }))
    })
  }
}

export const updatePlan = (data, accessToken, target) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_PLAN_PENDING'
    })
    return axios({
      data,
      method: 'put',
      headers: {'Authorization': `Bearer ${accessToken}`},
      url: `${baseAPI}/orders/${data.order_id}/plans/${data.id}`
    }).then((x) => {
      dispatch({
        type: 'UPDATE_PLAN_FULFILLED',
        payload: x.data
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'success',
        message: `Plan with the id ${x.data.id} updated`
      }))
      if (target) {
        dispatch(push(target))
      }
    }).catch((e) => {
      dispatch({
        type: 'UPDATE_PLAN_REJECTED',
        payload: e
      })
      dispatch(createFlash({
        id: Date.now(),
        type: 'error',
        message: `Update error`
      }))
    })
  }
}
